const kpiPageCopy = {
  analytics: {
    applications: {
      sectionTitle: 'Results by application',
      itemLabel: 'Application',
      singularLabel: 'application',
      pluralLabel: 'applications',
      chartToggleLabel: 'Applications',
      emptyHeadline: 'No applications yet',
      emptyDescription: 'When creators apply, they are offering to build with you. Those conversations will show up here.',
      emptySteps: [],
      filterEmptyNoun: 'applications',
      sparseEncouragement: 'Creators are starting to come to you. Keep campaigns live so the right people can find you.',
      lowVolumeHint: 'Applications are starting to come in. Keep campaigns live so creators can find you.',
    },
    invites: {
      sectionTitle: 'Results by invite',
      itemLabel: 'Invite',
      singularLabel: 'invite',
      pluralLabel: 'invites',
      chartToggleLabel: 'Invites',
      emptyHeadline: 'No invites sent yet',
      emptyDescription: 'An invite is how you start building with a creator—not a broadcast, a first conversation.',
      emptySteps: [],
      filterEmptyNoun: 'invites',
      sparseEncouragement: 'You have started asking creators to build with you. Keep going with people who fit.',
      lowVolumeHint: 'Keep inviting creators who fit your brand. One partnership can become the next.',
    },
    followers: {
      sectionTitle: 'Results by follower',
      itemLabel: 'Follower',
      singularLabel: 'follower',
      pluralLabel: 'followers',
      chartToggleLabel: 'New Followers',
      emptyHeadline: 'No followers yet',
      emptyDescription: 'When creators follow your brand, they are choosing to stay close. That interest will show up here.',
      emptySteps: [],
      sparseEncouragement: 'Creators are starting to follow you. Stay visible so interest can become a collaboration.',
      lowVolumeHint: 'Every new follower is someone paying attention. Invite the ones you want to build with.',
    },
    saved: {
      sectionTitle: 'Results by creator',
      itemLabel: 'Creator',
      singularLabel: 'saved creator',
      pluralLabel: 'saved creators',
      chartToggleLabel: 'Saved',
      emptyHeadline: 'No saved creators',
      emptyDescription: 'Save the creators you want to build with, then invite them when you are ready.',
      emptySteps: [],
      sparseEncouragement: 'You are starting a shortlist of people to build with. Invite them when a campaign is live.',
      lowVolumeHint: 'Keep saving creators who fit. Invite them when you launch the next campaign.',
    },
  },
  payments: {
    subtitle: 'What you paid the people building with you.',
    chartToggleLabel: 'Payouts',
    emptyTitle: 'No creator payouts yet',
    emptyBody: 'When you pay a creator on a collaboration, that spend will show up here.',
    emptySteps: [],
  },
  collaborationJourney: {
    emptyTitle: 'No accepted collaborations yet',
    emptyBody: 'When a creator accepts, the work of building together starts here.',
    pageTitle: 'Campaign Operations',
    pageIntro: 'Keep each collaboration moving so one partnership can become the next.',
    sectionUrgent: 'Urgent',
    sectionAtRisk: 'At Risk',
    sectionAction: 'Needs Action',
    sectionWaiting: 'Waiting on Creator',
    sectionComplete: 'Completed',
    emptyUrgent: 'No urgent blockers right now.',
    emptyAtRisk: 'No collaborations are at risk.',
    emptyAction: 'No pending actions right now.',
    emptyWaiting: 'Nothing is currently waiting on creators.',
    emptyComplete: 'No completed collaborations yet. Finished partnerships will appear here.',
  },
};

export default kpiPageCopy;
